import React from 'react';
import { Box, Typography } from '@mui/material';
import { ReactComponent as IconeMartin } from '../../../../assets/img/icone-martin.svg';

/**
 * Indica o que o assistente esta fazendo enquanto nao ha texto na tela.
 *
 * O backend manda a etapa e, quando e uma ferramenta, o nome interno dela. A
 * traducao para texto de usuario acontece aqui: o nome da ferramenta e detalhe
 * de implementacao e nao deve aparecer cru para quem le.
 */
const ROTULOS_FERRAMENTA = {
  listar_telas_do_usuario: 'Verificando suas telas'
};

const ROTULOS_ETAPA = {
  pensando: 'Pensando',
  consultando: 'Consultando dados',
  lendo_resultado: 'Analisando o resultado'
};

export default function StatusProcessamento({ status }) {
  if (!status) {
    return null;
  }

  const rotulo =
    (status.ferramenta && ROTULOS_FERRAMENTA[status.ferramenta]) ??
    ROTULOS_ETAPA[status.etapa] ??
    'Processando';

  return (
    <Box className="chat-ia-linha-assistente">
      <Box className="chat-ia-avatar" aria-hidden="true">
        <IconeMartin />
      </Box>

      <Box className="chat-ia-status" role="status" aria-live="polite">
        <Typography variant="body2" component="span" className="chat-ia-status-rotulo">
          {rotulo}
        </Typography>
        <Box component="span" className="chat-ia-status-pontos" aria-hidden="true">
          <span />
          <span />
          <span />
        </Box>
      </Box>
    </Box>
  );
}
